export default "__VITE_ASSET__9d51dca0__"